// extracted by mini-css-extract-plugin
export default {"portal":"src-shared-portal__portal"};